import Layout from '../../internal/Layout.vue'
import page from './videos.vue'

const VideoRoutes = {
  component: Layout,
  children: [
    {
      name: 'videos',
      path: '/',
      component: page,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default VideoRoutes
